import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Media_coverage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Media Coverage
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>News & PR</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Media Coverage</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="product_launch" ></section>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Media_coverage));